module.exports = __webpack_public_path__ + "media/sub7-1-1.0e65333e.mp4";